import firedux from '../firedux'

import {PRESENCE, PRESENCE_ENDPOINT} from '../../config/constants'
import {MAKE_CURRENT_USER_IDLE} from '../action_types'

export default (uid) => {
  firedux.ref.child(`${PRESENCE_ENDPOINT}/${uid}`).set(PRESENCE.AWAY)

  return {type: MAKE_CURRENT_USER_IDLE, uid}
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/make_current_user_idle.js
 **/